import { ChainId } from 'thena-sdk-core'

export const POOL_DEPLOYER_ADDRESSES: { [key: number]: string } = {
  [ChainId.BSC]: '0x06852dC9D6E44782Dd02994C368feBc4dC1b8a17',
  [ChainId.OPBNB]: '0x306F06C147f064A010530292A1EB6737c3e378e4'
}

export const POOL_INIT_CODE_HASHES: { [key: number]: string } = {
  [ChainId.BSC]: '0xb3fc09be5eb433d99b1ec89fd8435aaf5ffea75c1879e19028aa2414a14b3c85',
  [ChainId.OPBNB]: '0xc65e01e65f37c1ec2735556a24a9c10e4c33b2613ad486dd8209d465524bc3f4'
}

export const ADDRESS_ZERO = '0x0000000000000000000000000000000000000000'
export const FACTORY_ADDRESS = '0x30055F87716d3DFD0E5198C27024481099fB4A98'

/**
 * The default factory enabled fee amounts, denominated in hundredths of bips.
 */
export enum FeeAmount {
  LOWEST = 100,
  LOW = 500,
  MEDIUM = 3000,
  HIGH = 10000
}

/**
 * The default factory tick spacings by fee amount.
 */
export const TICK_SPACING: number = 60
